/**
 * @desc 列表
 */
const URL = "/rantion-mns";
import http, { updateResponse } from "@/http";
export function request(body: defs.mns.MessageCategoryRequestParamsDto, options?: any) {
  return updateResponse(
    http(URL + `/messageCategory/list`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
